if(typeof _GIRL_CONF['ice']['game_memory']=='undefined'){_GIRL_CONF['ice']['game_memory']={};};
_GIRL_CONF['ice']['game_memory']['face']={left:574,top:140,width:124,height:174};
_GIRL_CONF['ice']['game_memory']['hair1']={left:507,top:56,width:186,height:371};
_GIRL_CONF['ice']['game_memory']['hair2']={left:631,top:66,width:165,height:455};
_GIRL_CONF['ice']['game_memory']['hand1']={left:498,top:457,width:238,height:193};
_GIRL_CONF['ice']['game_memory']['hand2']={left:614,top:246,width:117,height:273};
_GIRL_CONF['ice']['game_memory']['item1']={left:247,top:241,width:228,height:438};
_GIRL_CONF['ice']['game_memory']['item2']={left:885,top:330,width:146,height:293};
_GIRL_CONF['ice']['game_memory']['tits']={left:514,top:365,width:122,height:128};
